export enum RoleStateStatus {
  GET_ROLE_REQUEST = 'ROLE_GET_ROLE_REQUEST',
  GET_ROLE_SUCCESS = 'ROLE_GET_ROLE_SUCCESS',
  GET_ROLE_FAILURE = 'ROLE_GET_ROLE_FAILURE',

  CREATE_ROLE_REQUEST = 'ROLE_CREATE_ROLE_REQUEST',
  CREATE_ROLE_SUCCESS = 'ROLE_CREATE_ROLE_SUCCESS',
  CREATE_ROLE_FAILURE = 'ROLE_CREATE_ROLE_FAILURE',

  UPDATE_ROLE_REQUEST = 'ROLE_UPDATE_ROLE_REQUEST',
  UPDATE_ROLE_SUCCESS = 'ROLE_UPDATE_ROLE_SUCCESS',
  UPDATE_ROLE_FAILURE = 'ROLE_UPDATE_ROLE_FAILURE',

  UPDATE_PASSWORD_REQUEST = 'ROLE_UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_SUCCESS = 'ROLE_UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE = 'ROLE_UPDATE_PASSWORD_FAILURE',

  DELETE_ROLE_REQUEST = 'ROLE_DELETE_ROLE_REQUEST',
  DELETE_ROLE_SUCCESS = 'ROLE_DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE = 'ROLE_DELETE_ROLE_FAILURE',

  CLEAR_ROLE_STATE = 'ROLE_CLEAR_STATE',
  SET_SELECTED_ROLE = 'ROLE_SET_SELECTED_ROLE',
}

export interface RoleDto {
  _id: string;
  name: string;
  permissions: string[];
}

export interface RoleState {
  isLoading: boolean;
  isError: boolean;
  roles: RoleDto[];
  error: string | null;
}
